import english from '@/locales/en.json'
import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: english,
  },
  warnHtmlInMessage: 'off',
})

type Languages = 'en'

const setDeviceLocale = async () => {
  const language = navigator.language as Languages
  if (i18n.global.availableLocales.includes(language)) {
    i18n.global.locale = language
  }
}

setDeviceLocale()
